import { Product } from '@voice/utils';

export interface ProductFormData {
  location?: string;
  selectedProduct?: Product;
  quantity: number;
  rate?: number;
  catalogRate?: number;
  description?: string;
  effectiveDate?: Date;
}

export interface StaticServiceFormData {
  location?: string;
  selectedStaticServiceCode?: { code: string; description?: string };
  quantity: number;
  rate?: number;
  catalogRate?: number;
  description?: string;
  effectiveDate?: Date;
}

export const formatCurrency = (value?: number | null): string => {
  if (value === undefined || value === null) {
    return '';
  }
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(value);
};

export const parseRateInput = (value: unknown): number | undefined => {
  if (value === null || value === '' || value === undefined) {
    return undefined;
  }
  const numValue = Number(value);
  return isNaN(numValue) ? undefined : numValue;
};

export const parseEffectiveDate = (
  date: Date | string | undefined
): Date | undefined => {
  if (!date) {
    return undefined;
  }
  if (date instanceof Date) {
    return date;
  }
  if (typeof date === 'string') {
    return new Date(date);
  }
  return undefined;
};

export const isValidProductForm = (
  formData: ProductFormData
): boolean => {
  return (
    !!formData.location &&
    !!formData.selectedProduct &&
    !!formData.quantity &&
    formData.quantity >= 1
  );
};

export const isValidStaticServiceForm = (
  formData: StaticServiceFormData
): boolean => {
  return (
    !!formData.location &&
    !!formData.selectedStaticServiceCode &&
    !!formData.quantity &&
    formData.quantity >= 1
  );
};
